import axios from 'axios'
import { BASE_URL } from './ApiGlobalInterface'
import AuthService from 'services/AuthService'

const api = axios.create({
  baseURL: BASE_URL
})

api.interceptors.request.use(
  async config => {
    const { accessToken, isLoggedIn } = AuthService.loadCookies()

    if (!isLoggedIn) {
      return Promise.reject(new Error('Not logged in'))
    }

    const updatedConfig = { ...config }
    updatedConfig.headers = updatedConfig.headers || {}

    if (accessToken) {
      updatedConfig.headers.Authorization = `Bearer ${accessToken}`
    }
    return updatedConfig
  },
  error => Promise.reject(error)
)

api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config

    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest.retryAttempt
    ) {
      originalRequest.retryAttempt = true

      try {
        const newToken = await AuthService.doTokenRefresh()

        if (newToken.ok) {
          originalRequest.headers.Authorization = `Bearer ${newToken.accessToken}`

          return api(originalRequest)
        }

        await AuthService.logoutAccount()
        return Promise.reject(error)
      } catch (refreshError) {
        await AuthService.logoutAccount()
        return Promise.reject(refreshError)
      }
    }

    return Promise.reject(error)
  }
)

export default api
